module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon5.5ed80bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon5.png
// module id = VwXe
// module chunks = 0